<template>
<article>
  
  <section>
    <div class="container">
      <h1 class="title has-text-centered">My Books</h1>
      <div class="content">
        <!--h2 v-if="!validProjects.length && loaded">No books here yet!</h2-->
        <b-table :data="validProjects" default-sort="createStamp">
          <b-table-column label="Created" sortable field="createStamp" v-slot="props">
            <span>{{props.row.createStamp/1000 | formatDate}}</span><br>
            <span>{{props.row.createStamp/1000 | formatTime}}</span>
          </b-table-column>
          <b-table-column label="Book" sortable field="projid" v-slot="props">
            <MyBookCard :projid="props.row.projid"
                        :flags="props.row.flags || {}"
                        :key="props.row.projid"
                        @click="gotoProject(props.row)"/>
          </b-table-column>
          <b-table-column v-slot="props">
            <b-dropdown class="button" position="is-bottom-left">
              <span slot="trigger">
                Actions <b-icon icon="menu-down"/>
              </span>
              <b-dropdown-item has-link>
                <a @click="gotoProject(props.row)">
                  <b-icon icon="book-open-variant"/> Preview and Buy
                </a>
              </b-dropdown-item>
              <b-dropdown-item has-link v-if="!props.row.flags.isLocked">
                <a v-if="devMode || !props.row.flags.isLocked" @click="doRefresh(props.row.projid)">
                  <b-icon icon="sync"/> Refresh from
                  <span v-if="props.row.projid.includes('nstagram_com')">Instagram</span>
                  <span v-else>Blog</span>
                </a>
              </b-dropdown-item>
              <b-dropdown-item has-link>
                <a @click="doDuplicate(props.row.projid)">
                  <b-icon icon="content-duplicate"/> Duplicate into a New Book</a>
              </b-dropdown-item>
              <hr class="dropdown-divider" v-if="!props.row.flags.isLocked && !props.row.flags.isDeleted">
              <b-dropdown-item has-link v-if="!props.row.flags.isLocked && props.row.flags.isDeleted">
                <a @click="doUndelete(props.row.projid)">
                  <b-icon icon="undo"/> Undelete!
                </a>
              </b-dropdown-item>
              <b-dropdown-item has-link v-if="devMode">
                <a v-if="props.row.flags.isLocked"
                   @click="doLock(props.row.projid, false)">
                  <b-icon icon="lock-open"/> DEV Unlock! </a>
                <a v-else @click="doLock(props.row.projid, true)">
                  <b-icon icon="lock"/> DEV Lock! </a>
              </b-dropdown-item>
            </b-dropdown>
          </b-table-column>
        </b-table>
      </div>
    </div>

    <b-modal :active.sync="showRefreshIndexer" :canCancel="['escape', 'x']" has-modal-card>
      <index-page :site="refreshSite" :projectid="refreshProjid" tag="mybooks-refresh"></index-page>
    </b-modal>

  </section>

  <section id="padding">
    <div class="container box">
      <index-launcher :title="projlist.length?'Make another?':'Create a blog book:'">
      </index-launcher>
    </div>
  </section>
  
</article>
</template>

<script>
import IndexLauncher from '@/components/IndexLauncher'
import IndexPage from '@/components/IndexPage'
import MyBookCard from '@/components/MyBookCard'
import Firebase from '../firebase.js'
var db = Firebase.database

function extractText(html) {
  if (!html) return '?'
  var el = document.createElement('template')
  el.innerHTML = '<div>'+html+'</div>'
  console.log(html, el, el.content.firstElementChild.innerText)
  return el.content.firstElementChild.innerText
}

export default {
  name: 'MyBooksPage',
  metaInfo: {
    title: 'My Books',
  },
  components: {
    IndexLauncher,
    IndexPage,
    MyBookCard,
  },
  data: function() { return {
    loaded: false,
    projindex: {},
    projectFlags: {},
    refreshSite: undefined,
    refreshProjid: undefined,
    showRefreshIndexer: false,
    updateCounter: 0,
    refreshCounter: 0,
  }},
  firebase: function() {
    return {
      projindex: { source: db.ref('/users/'+this.uid+'/index'),
                   readyCallback: function() { this.loaded = true } },
      projtrigger: db.ref('/users/'+this.uid+'/triggers/projectsIndex'),
    }
  },
  computed: {
    uid: function() {
      return this.$store.state.uid
    },
    projlist: function() {
      console.log('projlist:', this.projindex)
      return this.projindex.length ? this.projindex.map(a => a['.key']) : []
    },
    validProjects: function() {
      console.log('recalc validProjects:')
      return this.projindex
        .filter( p => this.refreshCounter
                 && this.projectFlags[p['.key']]
                 && !this.projectFlags[p['.key']].isInvalid  )
        .map( p => { return {projid: p['.key'],
                             createStamp: p.createStamp,
                             flags: this.projectFlags[p['.key']] } })
    },
    devMode: function() {
      return this.$store.state.dev.developmentClient
    },
  },
  methods: {
    projRef: function(projid) {
      return db.ref('/projects/'+this.uid+'/'+projid)
    },
    updateFlags: function(projid) {
      if (!this.projectFlags[projid]) {
        this.projectFlags[projid] = { updateRequested: true,
                                      isInvalid: false }
      }
      this.updateCounter++
      this.projRef(projid).child('isLocked').once('value').then(snap => {
        this.projectFlags[projid].isLocked = !!snap.val()
      })
      this.projRef(projid).child('selections/isDeleted').once('value').then(snap => {
        this.projectFlags[projid].isDeleted = !!snap.val()
      })
      this.projRef(projid).child('selections/volumes').once('value').then(snap => {
        this.projectFlags[projid].volumes = snap.val()
      })
      this.projRef(projid).child('posts').limitToLast(1).once('value').then(snap => {
        if (!snap.val()) {
          // no posts but maybe it was set to "false" while waiting for refresh
          this.projRef(projid).child('posts').once('value').then( snap => {
            if (snap.val() === null) {
              this.projectFlags[projid].isInvalid = true
            } else {
              this.projectFlags[projid].needsRefresh = true
            }
            this.updateCounter--
          })
        } else {
          this.updateCounter--
        }
      })
    },
    gotoProject: function(validProj) {
      if (validProj.flags.needsRefresh) {
        this.doRefresh(validProj.projid)
      } else {
        this.$router.push("/projects/"+validProj.projid)
      }
    },
    doDelete: function(projid) {
      this.projRef(projid).update({'selections/isDeleted': true})
      this.updateFlags(projid)
    },
    doUndelete: function(projid) {
      this.projRef(projid).update({'selections/isDeleted': false})
      this.updateFlags(projid)
    },
    doRefresh: function(projid) {
      this.projRef(projid).once('value', (snapshot) => {
        this.refreshSite = snapshot.val().site
        this.refreshProjid = projid
        this.$nextTick(function() {
          this.showRefreshIndexer = true
        })
      })
    },
    doDuplicate: function(projid) {
      this.projRef(projid).once('value', (snapshot) => {
        // point to the old content until we have our own by refresh
        var newproj = snapshot.val()
        newproj.contentsFallback = projid
        newproj.isLocked = false
        newproj.posts = false
        newproj.createStamp = {'.sv' : 'timestamp'}
        if (newproj.selections) {
          newproj.selections.configuredPosts = false
        }
        if (newproj.feed && newproj.feed.cms == 'instagram') {
          // 250212 - upgrade old projects to new graph api scraper
          newproj.feed.cms == 'instagram.graph'
        }
        var idroot = projid.replace(/(_1)+$/,'').replace(/(_[0-9a-z])$/,'')
        var dirref = db.ref('/projects/'+this.uid)        
        this.createDupeProject(dirref, projid, newproj)
      })
    },
    createDupeProject: function(dirref, projid, info) {
      projid = projid.replace(/(_1)+$/,'') //legacy scheme
      var dupeid = projid + '_0a'
      var matches = /(.*)_0([0-9a-z]+)$/.exec(projid)      
      if (matches) {
        var previd = parseInt(matches[2],36)
        previd = previd!=NaN ? previd||9 : 9        
        dupeid = matches[1] + '_0' + (previd+1).toString(36)
        //console.log('dupe increment', previd, '->', dupeid)
      }
      dirref.child(dupeid).transaction( (existing) => {
        console.log('dupe transaction', dupeid, existing)
        if (!existing) {
          return info
        }
      }, (error, committed, snapshot) => {
        if (error) {
          console.log('dupe transaction failed',dupeid);
        } else if (!committed) {
          console.log('dupe transaction aborted',dupeid);
          this.createDupeProject(dirref, dupeid, info)          
        } else {
          console.log('dupe transaction committed',dupeid, snapshot.val());
        }
      })
    },
    doLock: function(projid, lock) {
      this.projRef(projid).update({'isLocked': !!lock})
      this.updateFlags(projid)
    },
  },
  watch: {
    projlist: function(newVal) {
      if (newVal.length==0) {
        console.log('projlist needs building...')
        this.$firebaseRefs.projtrigger.set(new Date().getTime())
      } else {
        // check if this list was ever rebuild
        this.$firebaseRefs.projtrigger.once('value').then( snap => {
          var rebuildTimestamp = snap.val()
          if (!rebuildTimestamp) {
            console.log('projlist needs re-building...')
            this.$firebaseRefs.projtrigger.set(new Date().getTime())
          }
        })
      }
      newVal.forEach( projid => {
        this.updateFlags(projid)
      })
    },
    projtrigger: function(newVal) {
      console.log('projtrigger ', newVal)
    },
    updateCounter: function(newVal, oldVal) {
      if (newVal==0) {
        this.refreshCounter++
      }
    }
    
  },
}
</script>

<style scoped>
section {
    padding-top: 2em;
    padding-bottom: 2em;
}
.has-link {
    text-align: left;
}
.has-link .icon {
    margin-right: 1ex !important;
    margin-left: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/MyBooksPage.vue